import { useListLeases } from '@myrentalmate/api-client';
import { useMemo } from 'react';

import { okItems } from '../../lib/apiData';

/** Every lease, for a picker: where it is, and who's on it. */
export function useLeaseOptions(activeOnly = false) {
  const data = useListLeases({ page_size: 200 }).data;
  return useMemo(
    () =>
      okItems(data)
        .filter((lease) => !activeOnly || lease.status === 'active')
        .map((lease) => ({
          value: String(lease.id),
          label: `${lease.property_name} · ${lease.unit_number}${
            lease.residents.length ? ` (${lease.residents.map((r) => r.name).join(', ')})` : ''
          }`,
        })),
    [data, activeOnly],
  );
}
